import { render, staticRenderFns } from "./CopyInput.vue?vue&type=template&id=10154858&scoped=true&"
import script from "./CopyInput.vue?vue&type=script&lang=ts&"
export * from "./CopyInput.vue?vue&type=script&lang=ts&"
import style0 from "./CopyInput.vue?vue&type=style&index=0&id=10154858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10154858",
  null
  
)

export default component.exports